export default "__VITE_ASSET__12405055__"